module.exports = __webpack_public_path__ + "static/media/joinedTournaments_100_250.bb270390.png";